(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qh-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var section = document.currentScript.closest('.qhtc-testimonials-section')
               || document.querySelector('.qhtc-section');
    if (!section) return;

    var track   = section.querySelector('.qhtc-track');
    var slides  = Array.from(section.querySelectorAll('.qhtc-slide'));
    var prevBtn = section.querySelector('.qhtc-btn--prev');
    var nextBtn = section.querySelector('.qhtc-btn--next');
    var dotsEl  = section.querySelector('.qhtc-dots');

    if (!track || slides.length === 0) return;

    /* Hard-kill any inherited animation immediately */
    track.style.cssText += ';animation:none!important;transform:translateX(0%)';

    var current = 0;

    function getSlidesPerView() {
      var w = window.innerWidth;
      if (w <= 640)  return 1;
      if (w <= 1024) return 2;
      return 3;
    }

    function totalPages() {
      return Math.ceil(slides.length / getSlidesPerView());
    }

    function buildDots() {
      dotsEl.innerHTML = '';
      var pages = totalPages();
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.className = 'qhtc-dot' + (i === current ? ' qhtc-dot--active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () { goTo(idx); });
        })(i);
        dotsEl.appendChild(dot);
      }
    }

    function goTo(index) {
      var pages = totalPages();
      current = Math.max(0, Math.min(index, pages - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dotsEl.querySelectorAll('.qhtc-dot').forEach(function (dot, i) {
        dot.classList.toggle('qhtc-dot--active', i === current);
      });
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current >= pages - 1;
    }

    prevBtn.addEventListener('click', function () { goTo(current - 1); });
    nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Swipe */
    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
    });

    /* Resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        current = 0;
        buildDots();
        goTo(0);
      }, 150);
    });

    buildDots();
    goTo(0);

  })();

  } catch(e) { console.error(e); }
})();
})();
